import React, { useState, useEffect } from 'react'
import moment from 'moment'
import TrucksProduction from './TrucksProduction'
import TrucksShifts from './TrucksShifts'
import DriverLoads from './DriverLoads'
import AddTruck from './AddTruck'

const Trucks = props => {
  const [activeTab, setActiveTab] = useState('production')
  const [viewingDriver, setViewingDriver] = useState(false)
  const [currentDriver, setCurrentDriver] = useState()
  const [currentDriverLoads, setCurrentDriverLoads] = useState()

  const [updateSignOnOff, setUpdateSignOnOff] = useState(false)
  const [enterSignOnOff, setEnterSignOnOff] = useState(false)
  const [checkedSignOnOffs, setCheckedSignOnOffs] = useState([])
  const [addTruck, setAddTruck] = useState(false)

  const newDrivers = [
    ...new Set(
      props.activeNow.activeData.reduce((acc, cur) => {
        if (cur.driverLicencePlate) {
          acc.push(cur.driverLicencePlate)
        }
        return acc
      }, [])
    )
  ]

  const handleDriverPress = driver => {
    setCurrentDriver(driver)
    setViewingDriver(true)
    const loads = props.activeNow.activeData.filter(
      item => item.haulId === driver.haulId && driver.driverId === item.driverId
    )
    setCurrentDriverLoads(loads)
    props.history.push(`/app/active/trucks/loads/`)
  }

  useEffect(() => {
    if (props.location.pathname === '/app/active/trucks') {
      setCurrentDriver(null)
      setViewingDriver(false)
      setCurrentDriverLoads(null)
    }
  }, [props.location.pathname])

  const handleRadioButton = id => {
    const loadIndex = checkedSignOnOffs.findIndex(item => item === id)
    if (loadIndex > -1) {
      const newList = checkedSignOnOffs.filter(item => item !== id)
      setCheckedSignOnOffs(newList)
    } else {
      setCheckedSignOnOffs([...checkedSignOnOffs, id])
    }
  }

  const generateTitle = () => {
    if (updateSignOnOff) {
      return 'Select Trucks'
    } else if (enterSignOnOff) {
      return 'Enter Times'
    } else if (addTruck) {
      return 'Enter truck details'
    }
    const numTrucks = props.activeNow.drivers.length + newDrivers.length
    return numTrucks + (numTrucks === 1 ? ' Truck' : ' Trucks')
  }

  const generateTitleDetails = () => {
    if (updateSignOnOff) {
      return checkedSignOnOffs.length + ' selected'
    } else if (enterSignOnOff) {
      return ''
    } else if (addTruck) {
      return ''
    }
    return 'Last updated ' + moment().format('HH:mm')
  }

  const renderComponent = () => {
    if (viewingDriver) {
      return null
    }
    if (addTruck) {
      return <AddTruck setAddTruck={setAddTruck} foremanHaul={props.foremanHaul} />
    }
    if (activeTab === 'production') {
      return (
        <TrucksProduction
          {...props}
          handleDriverPress={handleDriverPress}
          setAddTruck={setAddTruck}
          isForeman={props.isForeman && props.foremanHaul}
        />
      )
    }
    if (activeTab === 'shifts') {
      return (
        <TrucksShifts
          {...props}
          setUpdateSignOnOff={setUpdateSignOnOff}
          updateSignOnOff={updateSignOnOff}
          setEnterSignOnOff={setEnterSignOnOff}
          enterSignOnOff={enterSignOnOff}
          handleRadioButton={handleRadioButton}
          checkedSignOnOffs={checkedSignOnOffs}
          setCheckedSignOnOffs={setCheckedSignOnOffs}
        />
      )
    }
  }

  return (
    <>
      <div style={{ margin: '16px' }}>
        {viewingDriver ? (
          <DriverLoads
            activeData={props.activeNow.activeData}
            currentDriverLoads={currentDriverLoads}
            currentDriver={currentDriver}
          />
        ) : (
          <>
            <div>
              <span style={{ color: '#6B6C70', fontSize: '16px' }}>
                {updateSignOnOff || enterSignOnOff
                  ? 'Sign On / Off'
                  : addTruck && props.isForeman
                  ? 'Add Truck'
                  : 'Active Now'}
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0 24px' }}>
              <span style={{ fontSize: '24px', color: '#3E3F42', fontWeight: '500' }}>
                {generateTitle()}
              </span>
              <span style={{ fontSize: '12px', alignSelf: 'flex-end' }}>
                {generateTitleDetails()}
              </span>
            </div>

            {!enterSignOnOff && !addTruck && (
              <div style={{ display: 'flex' }}>
                <div
                  style={
                    activeTab === 'production' ? { borderBottom: '2px solid #1565D8' } : undefined
                  }
                  onClick={() => setActiveTab('production')}
                >
                  <span>Production</span>
                </div>
                <div
                  style={{
                    marginLeft: '12px',
                    borderBottom: activeTab === 'shifts' ? '2px solid #1565D8' : undefined
                  }}
                  onClick={() => setActiveTab('shifts')}
                >
                  <span>Shifts</span>
                </div>
              </div>
            )}
          </>
        )}
        <div>
          {/* {!viewingDriver ? (
            activeTab === 'production' ? (
              <TrucksProduction
                {...props}
                handleDriverPress={handleDriverPress}
                setAddTruck={setAddTruck}
              />
            ) : (
              <TrucksShifts
                {...props}
                setUpdateSignOnOff={setUpdateSignOnOff}
                updateSignOnOff={updateSignOnOff}
                setEnterSignOnOff={setEnterSignOnOff}
                enterSignOnOff={enterSignOnOff}
                handleRadioButton={handleRadioButton}
                checkedSignOnOffs={checkedSignOnOffs}
                setCheckedSignOnOffs={setCheckedSignOnOffs}
              />
            )
          ) : (
            undefined
          )} */}
          {renderComponent()}
        </div>
      </div>
    </>
  )
}

export default Trucks
